var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVegetarianIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.511,
    height: 73,
    viewBox: "0 0 71.511 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1360.5 -412.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1389.075 414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1632.6,690",
    transform: "translate(-1592.545 -621.535)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.436,509.257H1476v-40L1485.668,450h20.718l11.05,19.259Z",
    transform: "translate(-1476 -440.792)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.138,474l-5.738,13.812v41.436",
    transform: "translate(-1540.301 -460.782)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.8,423.208V414h20.718v9.208",
    transform: "translate(-1504.132 -414)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476,528h17.129",
    transform: "translate(-1476 -499.721)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x2: 8.287,
    transform: "translate(6.906 37.209)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x2: 8.287,
    transform: "translate(6.906 46.14)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1362 417.696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1385.02,504.706c0,17.184-11.509,34.367-11.509,34.367S1362,521.89,1362,504.706c0-8.438,3.035-16.707,11.511-16.706S1385.02,496.268,1385.02,504.706Z",
    transform: "translate(-1362 -472.768)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x2: 10.987,
    y2: 0.001,
    transform: "translate(0.523 25.312)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.001,
    x2: 10.987,
    transform: "translate(0.523 33.195)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.001,
    x2: 9.417,
    transform: "translate(2.093 41.078)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x2: 7.848,
    y2: 0.001,
    transform: "translate(3.662 48.961)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 14.734,
    transform: "translate(11.51)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.838,
    y1: 12.746,
    transform: "translate(2.96 3.978)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.838,
    y2: 12.746,
    transform: "translate(16.282 3.978)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetarianIcon);
export default __webpack_public_path__ + "static/media/vegetarian-icon.d8a9baa1.svg";
export { ForwardRef as ReactComponent };